module.exports = __webpack_public_path__ + "media/images/front/products/caja_la_solea_bio-059d82aba388c625d151cba436edf8b9.png";